import DEFAULT_PICKERSDAY_CLASS_NAME from '../../constants/pickers-day';

export const defaultPickersDayStyles = ({ theme, ownerState, mainColor }) => ({
  ...(ownerState.selected && {
    backgroundColor: mainColor,
    color: theme.palette.common.white,
    fontWeight: '600',
    '&:hover': {
      backgroundColor: mainColor,
    },
    '&:focus': {
      backgroundColor: mainColor,
    },
    '&.Mui-selected': {
      backgroundColor: mainColor,
    },
    '&.Mui-selected:hover': {
      backgroundColor: mainColor,
    },
    '&.Mui-selected:focus': {
      backgroundColor: mainColor,
    },
  }),
});

const MuiPickersDay = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      [`&.${DEFAULT_PICKERSDAY_CLASS_NAME}`]: defaultPickersDayStyles({ theme, ownerState, mainColor: theme.palette.primary.main }),
    }),
  },
};

export default MuiPickersDay;
